import { render } from "./SvgIcon.vue?vue&type=template&id=046afcce"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__